import { render } from "./UStrongPassword.vue?vue&type=template&id=4b7fdffe&scoped=true"
import script from "./UStrongPassword.vue?vue&type=script&lang=ts"
export * from "./UStrongPassword.vue?vue&type=script&lang=ts"

import "./UStrongPassword.vue?vue&type=style&index=0&id=4b7fdffe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b7fdffe"

export default script